if ( jQuery( '.three-latest-news-cards .blog-container' ).length ) {
  jQuery( document ).ready( function() {
    // if (jQuery(window).width() < 768) {
    jQuery( '.three-latest-news-cards .blog-container' ).slick( {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: jQuery( '.three-lastest-news-cards.prev' ),
      nextArrow: jQuery( '.three-latest-news-cards.next' ),
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    } );
    // }
  } );

  jQuery( document ).ready( function() {
    if ( jQuery( window ).width() < 1024 ) {
      jQuery( '.three-latest-news-cards .view-all-container' ).insertAfter( '#threeLatestNewsCardsArrowsContainer' );
      jQuery( '.three-latest-news-cards .view-all-container' ).css( 'text-align', 'center' );
      jQuery( '.three-latest-news-cards .view-all-container' ).css( 'margin', 'auto' );
      jQuery( '.three-latest-news-cards .view-all-container' ).css( 'margin-top', '20px' );
    }
  } );
}
